import { SelectEffect, select } from "redux-saga/effects";

import { featureToggle } from "Store/featureToggles/featureToggleUtils";
import { ReduxState } from "Store/rootReducer";
import { FeatureToggle } from "./featureToggleTypes";

export const isToggled = (toggle: FeatureToggle): SelectEffect =>
  select((state: ReduxState) =>
    featureToggle(state.texts.domain.featureToggles[toggle]),
  );
